<template>
    <QPop class="pop-self" v-model="show" @close="handleClose" :contentIsScroll="false">
        <div class="pop-content-wrapper">
            <div class="pop-bg">
                <img class="pop-bg-top" src="../assets/images/pop_img_bg.png" alt="">
            </div>
            <div class="pop-content">
                <slot></slot>
            </div>
        </div>
    </QPop>
</template>
<script lang="ts" setup>
import { ref, onMounted, watch } from 'vue';
import { QPop } from '@q-front-npm/h5-ui';

const props = defineProps({
    show: {
        type: Boolean,
        default: false,
    },
    btnText: {
        type: String,
        default: '',
    },
});
const emit = defineEmits(['update:show', 'close', 'btnClick']);

const show = ref(false);
watch(() => props.show, (newVal) => {
    show.value = newVal;
});

const handleClose = () => {
    // emit('update:show', false);
    emit('close');
};

const handleBtnClick = () => {
    emit('btnClick');
};

onMounted(() => {
    console.log('pop mounted', props.show);
});
</script>

<style lang="scss" scoped>
.pop-self {
    position: relative;
}
.pop-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    z-index: -1;
    img {
        position: relative;
        width: 100%;
    }
}
.pop-content-wrapper {
}
.pop-content {
    position: relative;
    overflow: hidden;
    width: 496px;
    height: 630px;
}
.pop-content-btn {
    margin-top: 48px;
    position: relative;
    text-align: center;
    line-height: 80px;
    width: 100%;
    font-weight: bold;
    font-size: 32px;
    color: #FFFFFF;
    img {
        width: 400px;
        height: 80px;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: 0;
        z-index: -1;
    }
}
</style>
<style lang="scss">
.pop-self {
    --q-popup-bg-color: transparent!important;
    --q-overlay-bg-color: rgba(0, 0, 0, 0.8)!important;
    .q-popup-center {
        width: 496px!important;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
}
</style>
